<template>
  <div>
    <div class="inner">
        <a class="logo"></a>
        <div class="nav" v-if="hasNav">
          <a :class="{active: active == 0}" @click="changeNav(0)">首页</a>
          <a :class="{active: active == 1}" @mouseenter="navShow = true">软件/产品</a>
          <a :class="{active: active == 2}" @click="changeNav(2)">个人中心</a>
          <a :class="{active: active == 3}" @click="changeNav(3)">常见问题</a>
          <a :class="{active: active == 4}" @click="changeNav(4)">风险揭示</a>
          <ul class="left_nav" v-show="navShow">
            <li v-for="item in list" :class="{active: isActive(item),open: isOpen(item)}" :key="item.id">
                <div class="nav_title" @click.self="changeNav_left(item)">
                    {{item.name}}
                    <a class="arrow" @click.self="changeNav_left(item)"
                        v-show="item.sub && item.sub.length > 0 && item.isShow"></a>
                </div>
                <ul class="sub_list" v-show="item.sub && item.sub.length > 0 && item.isShow">
                    <li v-for="subitem in item.sub" :class="{active: isActive(subitem)}"
                        @click.self="changeNav_left(subitem)" :key="subitem.id">{{subitem.name}}</li>
                </ul>
            </li>
        </ul>
        </div>
        <div class="tips">
            Tel： 400-811-3366<span>（工作日8：00 - 18：00）</span>
          <!-- （工作日8:00～22:00，五一、十一、<br>春节初三至初六16:30～20:30） -->
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import config from '../assets/js/config'

export default {
  name: 'Topnav',
  inject: ['navCall'],
  data: ()=>({
    active:0,
    navShow: false,
    list: []
  }),
  components: {
    
  },
  computed: {
    hasNav () {
        return config.topNav.includes(this.$route.name)
    }
  },
  methods: {
    changeNav (x) {
      this.active = x
      this.navCall && this.navCall(x)
    },
    /**切换左侧导航时的函数(changeNav_left)
     * params:
     *   item {Object}
     */
    changeNav_left(item) {
        if (item.sub && item.sub.length > 0 && item.isShow) {
            item.open = !item.open
        }
        if ((!item.sub || item.sub.length == 0 || !item.isShow) && (this.$route.params.id != item.id || item.sub)) {
            this.list.forEach(v => {
                v.open = null
            })
            let _id = item.id
            if (!item.isShow && item.sub && item.sub.length > 0) {
                _id = item.sub[0].id
            }
            if (this.$route.params.id == _id) return
            this.clearVuex()
            this.$router.push({
                path: '/detail/'+_id
            })
        }
        if (item.isPreview && this.$route.name != 'Preview') {
            this.$router.push({path: '/preview'})
        }
    },
    isActive(item) {
        let isgroup = item.sub != undefined
        let result =  item.id && this.$store.state.subnav.find(v => {
            let _isgroup = v.sub != undefined 
            return  v.id == item.id && isgroup == _isgroup
        })
        return result
    },
    isOpen(item) {
        if (item.open && item.open != null) {
            return true
        } else {
            return false
        }
    },
    clearVuex () {//清空vuex的账号验证相关数据
        this.$store.commit('renewbuy/setCrossFlag',false)
        this.$store.commit('renewbuy/setInfo',null)
        this.$store.commit('addbuy/setUserInfo',{
            user: '',
            password: '',
            fetchData: null
        })
        this.$store.commit('addbuy/setPrice',0)
        this.$store.commit('setOtherId','')
    },
  },
  watch:{
      "$route": {
          handler (val) {
              if (val.name == 'Detail') {
                  this.active = 1
              }
          },
          immediate: true
      },
      navShow(val) {
        if(val) {
            document.body.addEventListener('click', () => {
              this.navShow = false;
            })
          } else {
            document.body.removeEventListener('click', () => {});
          }
        }
  },
  
  mounted () {
      if (this.$route.name == 'Risk') {
          this.active = 4
      } else if (this.$route.name == 'Question') {
          this.active = 3
      } else if (this.$route.name == 'Home') {
          this.active = 0
      } else {
          this.active = 1
      }

      var self = this
      //请求导航数据
      var url = this.$route.name != 'Preview' ? "/api/Home/ProductListNavi" : "/Api/ProductListNavi?pid=" + this.$route.query.pid + "&appid=" + this.$route.query.appid
      this.$axios({
          url: url,
          method: "get"
      })
      .then(res => {
          
          self.list = res.data.map(v => {
              let obj = {
                  name: v.categoryName,
                  id: v.id,
                  enCategory: v.enCategory,
                  open: null,
                  icon: v.productImgUrl,
                  isShow: v.isShow,
                  isPreview: this.$route.name == 'Preview' ? true : false
              }
              if (v.productList && v.productList.length > 0) {
                  obj.sub = v.productList.map(val => ({
                      name: val.productName,
                      id: val.id
                  }))
              }
              return obj
          })

          //根路由默认跳转第一个产品
          // if (this.$route.name == 'Home') {
          //     this.$router.push({
          //       name: "Detail",
          //       params: {
          //         id: this.list[0].sub[0].id
          //       }
          //     })
          // }
          
          //计算云主机所拥有的分类，并存入vuex
          let cloud = res.data.find(v => v.isYun)
          if (!cloud) return
          let cloudVarity = cloud.ids.map(v => {
              if (v == 39) {
                  return {
                      id: 39,
                      name: 'Ⅱ型（四核4G内存）'
                  }
              } else if (v == 78) {
                  return {
                      id: 78,
                      name: 'Ⅲ型（四核8G内存）'
                  }
              } else if (v == 79) {
                  return {
                      id: 79,
                      name: 'Ⅳ型（八核16G内存）'
                  }
              }
          })
          this.$store.commit('setYunVarity', cloudVarity)


          //培训课程的所有班级，存入vuex
          let peixun = res.data.find(v=>v.isMai)
          if (!peixun) return
          let peixunVarity = []
          peixun.ids.forEach(v=>{
              /*if (v==46) {
                  peixunVarity.push({
                      id: 46,
                      name: '麦语言'
                  })
              } else */if (v == 107) {
                  peixunVarity.push({
                      id: 107,
                      name: '麦语言'
                  })
              }
          })
          this.$store.commit('setLessonVarity', peixunVarity)
      })
      .catch(err => {
          
          this.$market.alert({content: '服务器错误，请稍后再试。'})
      });
  }
}
</script>

<style scoped>
  .inner{
    /* width: 1360px; */
    width: 1270px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  .logo {
    display: block;
    width: 240px;
    height: 60px;
    background: url(../assets/image/logo.png) no-repeat left 15px;
    margin: 6px 0 0 0;
    float: left;
  }
  .nav {
    /* padding: 26px 0 0 205px; */
    padding: 26px 0 0 121px;
    float: left;
    position: relative;
  }
  .nav a {
    margin: 0 30px;
    float: left;
    cursor: pointer;
    font-size: 15px;
  }
  .nav a:hover,.nav a.active {
    color: rgb(0, 52, 136);
    border-bottom: 2px solid rgb(0, 52, 136);
    padding-bottom: 10px;
  }
  .tips{
    color: #808080;
    padding: 4px 0 4px 15px;
    position: absolute;
    right: 0;
    top: 22px;
    font-size: 14px;
  }
  .tips span {
    font-size: 12px;
    color:rgb(152, 152, 152);
    vertical-align: text-top;
  } 
  .left_nav{
    position: absolute;
    left: 241px;
    top: 61px;
    padding: 8px 5px;
    margin: 0;
    list-style: none;
    background: #ffffff;
    z-index: 9;
    box-shadow: 0 0 5px #6eb2ff;
  }
  .left_nav>li{
    line-height: 24px;
    padding: 0 10px;
    margin: 2px 0;
    color: #737373;
    cursor: pointer;
    font-size: 14px;
  }
  .left_nav>li:hover,
  .left_nav>li.active{
    background-color: #eaf4fe;
    color: #3f58c7;
  }
</style>>